module.exports = __webpack_public_path__ + "img/mclogi-mobile1@2x.5759fb3.png";